import { afterNextRender, Component, effect, forwardRef, inject, input, linkedSignal, output, signal, untracked } from '@angular/core';
import { SharedUI } from '@sharedUI/exports';
import { AbstractControl, FormBuilder, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AbstractControl as AC } from '../abstract-control/abstract-control';
import type { SoInputSuggestion } from '@sharedUI/so-input/so-input.component';

@Component({
  selector: 'app-input-ia-prompt',
  imports: [ ReactiveFormsModule, SharedUI ],
  templateUrl: './input-ia-prompt.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputIAPrompt),
      multi: true,
    },
  ],
})
export class InputIAPrompt extends AC<string, string> {
  // Servicios
  fb = inject(FormBuilder);

  // Inputs
  override $value = input<string>('', { alias: 'value' });
  $_value = linkedSignal(this.$value);
  $placeholder = input<string>('', { alias: 'placeholder' });
  $buttonText = input<string>('', { alias: 'buttonText' });
  $aiLoaderText = input<string>('Procesando...', { alias: 'aiLoader' });
  $processing = input<boolean>(false, { alias: 'processing' });
  $minPromptLength = input<number>(1, { alias: 'minPromptLength' });
  $cleanAfterSubmit = input<boolean>(false, { alias: 'cleanAfterSubmit' });
  $suggestions = input<SoInputSuggestion[]>([], { alias: 'suggestions' });

  // Constructor
  constructor() {
    super();
    afterNextRender(() => {
      this.onStrValueChange(this.$_value());
    });

    effect(() => {
      if (!this.$processing() && this.$cleanAfterSubmit() && this.firstSubmitDone)
        this.onStrValueChange('');
    });
  }

  // Outputs
  override valueChange = output<string>();
  clicked = output<string>();

  // Signals / atributos
  form = this.fb.group({
    prompt: [ this.$_value() ],
  });
  promptControl = this.form.get('prompt');
  override $controlValue = signal<string>('');
  firstSubmitDone = false;

  // Maneja el evento de entrada de texto
  override onValueChange(event: Event) {
    this.onStrValueChange((event.target as HTMLInputElement).value);
  }

  // Maneja el evento de cambio de texto
  onStrValueChange(newValue: string) {
    if (this.$value() !== undefined)
      this.$_value.set(newValue);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
    (this.promptControl as AbstractControl).setValue(newValue);
  }

  // Maneja el evento de click sobre el botón
  onButtonClicked() {
    this.firstSubmitDone = true;
    this.clicked.emit(this.$_value());
  }
}
